import { jsxs as l, jsx as o } from "react/jsx-runtime";
import { useTranslation as T } from "react-i18next";
import "react";
import "dayjs";
import { isMobileDevice as d } from "../../../../../helpers/device-helper.js";
import "../../../../../contexts/global-context.js";
import "motion/react";
import { OutlineButton as u, SecondaryButton as D } from "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import { Dialog as N } from "../../../../../components/elements/dialog/dialog.js";
import { FilterGroup as _ } from "../filter-group/filter-group.js";
import t from "./filter-dialog.module.less.js";
const g = ({
  filterGroups: a,
  isOpen: s,
  selectedFilters: m,
  onClose: r,
  onChange: n,
  onClear: p,
  onApprove: c
}) => {
  const f = d(), { t: i } = T();
  return /* @__PURE__ */ l(
    N,
    {
      title: i("FIND_STATION_FILTER_MODAL_TITLE"),
      ariaDescription: i("FIND_STATION_FILTER_MODAL_ARIA_DESCRIPTION"),
      isModal: !0,
      disableOnInteractOutside: !!f,
      isOpen: s,
      onClose: r,
      onEscapeKeyDown: r,
      anchor: "left",
      contentClassName: t.dialogContent,
      children: [
        /* @__PURE__ */ o("div", { className: t.filterWrapper, children: a.map((e, I) => /* @__PURE__ */ o(
          _,
          {
            filters: e.filters,
            title: e.title,
            onChange: n,
            selectedFilters: m
          },
          I
        )) }),
        /* @__PURE__ */ l("div", { className: t.actionFooter, children: [
          /* @__PURE__ */ o(u, { onClick: p, label: i("CLEAR"), className: t.filterButton }),
          /* @__PURE__ */ o(D, { onClick: c, label: i("SHOW_RESULTS"), className: t.filterButton })
        ] })
      ]
    }
  );
};
export {
  g as FilterDialog
};
